import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetChartAccountTransactions } from "../../../hooks/api/queries";
import { getUrlQuerysection } from "../../../helpers";

const useChartAccountDetails = ({ account_id }) => {
  const [search, setSearch] = useSearchParams();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [currentStore, setCurrentStore] = useState(search.get("store_id"));
  const [entrySource, setEntrySource] = useState(search.get("entry_source"));

  const [startDate] = useState(search.get("start_date"));
  const [endDate] = useState(search.get("end_date"));
  const [showDepositCash, setShowDepositCash] = useState(false);
  const [showWithdrawCash, setShowWithdrawCash] = useState(false);
  const [showTransferCash, setShowTransferCash] = useState(false);
  const [showExportAccountStatement, setShowExportAccountStatement] =
    useState(false);

  const params = new URLSearchParams(getUrlQuerysection());
  params.set("chart_account_id", account_id);
  const queries = `?${params.toString()}`;

  const {
    isLoading: isLoadingChartAccountTransactions,
    data: chartAccountTransactions,
    refetch: handleFetchChartAccountTransactions,
  } = useGetChartAccountTransactions({
    queries,
    enabled: Boolean(account_id),
  });

  const gotoPage = (pageNumber) => {
    search.set("page", pageNumber);
    setSearch(search, { replace: true });
  };

  const setDateFilter = (data) => {
    search.set("start_date", data.startDate);
    search.set("end_date", data.endDate);
    setSearch(search, { replace: true });
  };

  const filterByStoreId = (storeId) => {
    if (storeId === "ALL_STORES") search.delete("store_id");
    else search.set("store_id", storeId);
    setCurrentStore(storeId);
    setSearch(search, { replace: true });
  };

  const setEntrySourceFilter = (source) => {
    if (!source) search.delete("entry_source");
    else search.set("entry_source", source);
    setEntrySource(source);
    setSearch(search, { replace: true });
  };

  return {
    storeList,
    currentStore,
    startDate,
    endDate,
    chartAccountTransactions: chartAccountTransactions?.data || [],
    metaDetails: chartAccountTransactions?.meta,
    isLoadingChartAccountTransactions,
    showDepositCash,
    showWithdrawCash,
    showTransferCash,
    showExportAccountStatement,
    entrySource,
    handleFetchChartAccountTransactions,
    gotoPage,
    setDateFilter,
    filterByStoreId,
    setShowDepositCash,
    setShowWithdrawCash,
    setShowTransferCash,
    setShowExportAccountStatement,
    setEntrySourceFilter,
  };
};

export default useChartAccountDetails;
